import { DateFormatType } from '@/modules/core/domain/interfaces';
import { CloseIcon } from '@chakra-ui/icons';
import { Button, ButtonGroup, IconButton } from '@chakra-ui/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { QueryDateModel } from './localGeneric';
import { Label } from './styles';

const ChakraRangeDateFilterView: React.FC<any> = ({
  title,
  onSelect,
  isRange,
  selected,
  dateFormat,
  isMobile,
  initialSelected,
  onClear,
}) => {
  const [dateStart, setDateStart] = useState<string>(() => {
    if (initialSelected && typeof initialSelected === 'string') {
      return `${moment(initialSelected).utc().unix()}`;
    }

    if (
      initialSelected &&
      typeof initialSelected === 'object' &&
      initialSelected.dateStart
    ) {
      return `${moment(initialSelected.dateStart).utc().unix()}`;
    }

    return '';
  });
  const [dateEnd, setDateEnd] = useState<string>(
    initialSelected &&
      typeof initialSelected === 'object' &&
      initialSelected.dateEnd
      ? `${moment(initialSelected.dateEnd).utc().unix()}`
      : '',
  );
  const [query, setQuery] = useState<string | QueryDateModel>();
  const firstPickerName: string = isRange ? 'De:' : '';

  const onGetDateStart = (newDate: string) => {
    if (!isRange) {
      setDateStart(newDate);
      onSelect(newDate);
      return;
    }
    const newQuery: QueryDateModel = { ...(query as QueryDateModel) };
    const parsedDate: string =
      dateFormat === DateFormatType.DEFAULT_TIMESTAMP
        ? newDate
        : moment(Number(newDate) * 1000).format('YYYY-MM-DD');

    newQuery.dateStart = parsedDate;
    onSelect(newQuery);
    setDateStart(newDate);
  };

  const onGetDateEnd = (newDate: string) => {
    setDateEnd(newDate);
    const newQuery: QueryDateModel = { ...(query as QueryDateModel) };
    const parsedDate: string =
      dateFormat === DateFormatType.DEFAULT_TIMESTAMP
        ? newDate
        : moment(Number(newDate) * 1000).format('YYYY-MM-DD');

    newQuery.dateEnd = parsedDate;
    onSelect(newQuery);
    setDateEnd(newDate);
  };

  useEffect(() => {
    if (selected) {
      if (selected.dateStart)
        setDateStart(`${moment(selected.dateStart).utc().unix()}`);
      if (selected.dateEnd)
        setDateEnd(`${moment(selected.dateEnd).utc().unix()}`);
    }
  }, [selected]);

  if (!selected) return <></>;

  return (
    <>
      <ButtonGroup
        size="sm"
        isAttached
        variant="outline"
        backgroundColor="white"
        onClick={(e) => {
          // preventCall
          e.preventDefault();
          e.stopPropagation();
        }}
        onKeyDown={(e) => {
          // preventCall
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Label>{title}</Label>
        <Button
          aria-label="Value Filter"
          borderInline="none"
          borderStartRadius="0"
          paddingStart="0rem"
          paddingEnd="0.2rem"
          fontSize="14px"
          onClick={(e) => {
            // preventCall
            e.preventDefault();
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            // preventCall
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {moment(Number(dateStart) * 1000).format('DD/MM/YYYY')}
        </Button>
        <Button
          aria-label="Action Filter"
          borderInline="none"
          borderStartRadius="0"
          paddingX="0"
          fontSize="14px"
          onClick={(e) => {
            // preventCall
            e.preventDefault();
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            // preventCall
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          até
        </Button>
        <Button
          aria-label="Value Filter"
          borderInline="none"
          borderStartRadius="0"
          paddingStart="0"
          paddingEnd="0.4rem"
          fontSize="14px"
          onClick={(e) => {
            // preventCall
            e.preventDefault();
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            // preventCall
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {moment(Number(dateEnd) * 1000).format('DD/MM/YYYY')}
        </Button>
        <IconButton
          aria-label="Close Filter"
          icon={<CloseIcon />}
          borderStart="none"
          borderStartRadius="0"
          onClick={onClear}
        />
      </ButtonGroup>
    </>
  );
};

export default ChakraRangeDateFilterView;
